import { ESBanner } from '@/modules/pmt/components/ShipmentsOverview/components/ESBanner';
import { ShipmentFilter } from '@/modules/pmt/components/ShipmentsOverview/components/FilterActions/ShipmentFilter';
import { ShipmentSort } from '@/modules/pmt/components/ShipmentsOverview/components/FilterActions/ShipmentSort';
import { ShipmentList } from '@/modules/pmt/components/ShipmentsOverview/components/ShipmentList';
import { SyncInProgressBanner } from '@/modules/pmt/components/SyncInProgressBanner';
import { useEmailSyncContext } from '@/modules/pmt/context';
import type { FC } from 'react';
import { ListWithScrollbarWrapper, ShipmentFiltersWrapper, ShipmentListWrapper } from './ShipmentListLayout.styles';

export const ShipmentListLayout: FC = () => {
  const { hasEmailConnected, isEmailSyncAllowed, hasEmailAccounts } = useEmailSyncContext();

  const renderEsyncCTA = () => {
    switch (true) {
      case !isEmailSyncAllowed && !hasEmailAccounts: // No email accounts connected before and not allowed email sync
        return null;

      case !hasEmailAccounts: // No email accounts connected before and has parcels
      case hasEmailAccounts && !hasEmailConnected: // Has email accounts connected before but no email connected
        return <ESBanner />;

      default:
        return null;
    }
  };

  return (
    <>
      <ShipmentFiltersWrapper>
        <ShipmentFilter />
        <ShipmentSort />
      </ShipmentFiltersWrapper>

      <ListWithScrollbarWrapper>
        <ShipmentListWrapper hasEmailAccounts={hasEmailAccounts}>
          <SyncInProgressBanner />
          {renderEsyncCTA()}
          <ShipmentList />
        </ShipmentListWrapper>
      </ListWithScrollbarWrapper>
    </>
  );
};
